import ProyectoForm from "../forms/ProyectoForm";
import PasoForm from "../forms/PasoForm";
import BorrarProyectoForm from "../forms/BorrarProyectoForm";
import ProtocoloForm from "../forms/ProtocoloForm";

// Los modales de la seccion Proyectos (proyecto, paso, archivar, borrar y
// protocolos). Se pintan dentro del marco de modal que pone App; `modal` es lo que
// decide cual toca.

export default function ModalesProyecto({ modal, setModal, inS, lbS, teams, users, currentUser, proyectos, setProjAbierto, setProjTab }) {
  return (
    <>
      {modal==="nuevoProyecto"&&(
        <ProyectoForm inS={inS} lbS={lbS} teams={teams} users={users} currentUser={currentUser}
          onSave={async d=>{
            const p = await proyectos.createProyecto(d);
            setModal(null);
            // Se entra directo al proyecto recien creado: lo primero que
            // se quiere hacer es ponerle pasos.
            if(p?.id){ setProjAbierto(p.id); proyectos.loadProyecto(p.id); }
          }}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="editarProyecto"&&(
        <ProyectoForm inS={inS} lbS={lbS} teams={teams} users={users} currentUser={currentUser}
          proyecto={modal.proyecto}
          onSave={async d=>{ await proyectos.updateProyecto(modal.proyecto.id, d); setModal(null); }}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="nuevoPaso"&&(
        <PasoForm inS={inS} lbS={lbS} users={users} teams={teams}
          miembros={proyectos.detalle?.miembros||[]}
          onSave={async d=>{ await proyectos.createTarea(modal.projectId, d); setModal(null); }}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="editarPaso"&&(
        <PasoForm inS={inS} lbS={lbS} users={users} teams={teams}
          paso={modal.paso} miembros={proyectos.detalle?.miembros||[]}
          onSave={async d=>{ await proyectos.updateTarea(modal.projectId, modal.paso.id, d); setModal(null); }}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="borrarPaso"&&(
        <div>
          <div data-titulo="1" style={{fontWeight:800,fontSize:16,marginBottom:8,color:"var(--text)"}}>
            ¿Eliminar «{modal.tarea?.title}»?
          </div>
          <div style={{fontSize:12.5,color:"var(--text3)",lineHeight:1.6,marginBottom:18}}>
            Se borra el paso y las conexiones del flujo que salgan o lleguen a el.
            Las horas que ya se le hayan imputado en el cuaderno no se borran: se
            quedan contadas en el proyecto, pero sin paso al que colgarse.
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button className="btn" onClick={()=>setModal(null)}
              style={{padding:"8px 16px",borderRadius:9,border:"1px solid var(--border)",
                cursor:"pointer",fontSize:13,background:"var(--surface2)",
                color:"var(--text2)",fontFamily:"var(--font)"}}>Cancelar</button>
            <button className="btn"
              onClick={async()=>{ await proyectos.deleteTarea(modal.projectId, modal.tarea.id); setModal(null); }}
              style={{padding:"8px 16px",borderRadius:9,border:"none",cursor:"pointer",
                fontSize:13,fontWeight:600,background:"var(--danger)",color:"var(--on-danger)",
                fontFamily:"var(--font)"}}>Eliminar</button>
          </div>
        </div>
      )}
      {modal?.type==="archivarProyecto"&&(
        <div>
          <div data-titulo="1" style={{fontWeight:800,fontSize:16,marginBottom:8,color:"var(--text)"}}>
            ¿Archivar «{modal.proyecto?.name}»?
          </div>
          <div style={{fontSize:12.5,color:"var(--text3)",lineHeight:1.6,marginBottom:18}}>
            Sale de la lista de proyectos, y nada mas. Sus pasos, su historial y las
            horas que se le hayan imputado siguen donde estan, y puedes recuperarlo
            cuando quieras marcando <b>Incluir archivados</b> en los filtros.
          </div>
          <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
            <button className="btn" onClick={()=>setModal(null)}
              style={{padding:"8px 16px",borderRadius:9,border:"1px solid var(--border)",
                cursor:"pointer",fontSize:13,background:"var(--surface2)",
                color:"var(--text2)",fontFamily:"var(--font)"}}>Cancelar</button>
            <button className="btn"
              onClick={async()=>{
                const ok = await proyectos.archivarProyecto(modal.proyecto.id);
                setModal(null);
                if(ok){ setProjAbierto(null); proyectos.setDetalle(null); }
              }}
              style={{padding:"8px 16px",borderRadius:9,border:"1px solid var(--warn-line)",
                cursor:"pointer",fontSize:13,fontWeight:600,background:"var(--warn-bg)",
                color:"var(--warn-text)",fontFamily:"var(--font)"}}>Archivar</button>
          </div>
        </div>
      )}
      {modal?.type==="borrarProyecto"&&(
        <BorrarProyectoForm proyecto={modal.proyecto} inS={inS} lbS={lbS}
          onBorrar={async()=>{
            const ok = await proyectos.borrarProyecto(modal.proyecto.id);
            setModal(null);
            if(ok){ setProjAbierto(null); proyectos.setDetalle(null); }
          }}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="guardarProtocolo"&&(
        <ProtocoloForm modo="guardar" origen={modal.proyecto} teams={teams}
          pasos={modal.pasos}
          inS={inS} lbS={lbS}
          onSave={async d=>{
            const p = await proyectos.guardarComoPlantilla(modal.proyecto.id, d);
            setModal(null);
            // Se lleva al estante de protocolos y no al protocolo recien
            // creado: lo que se acaba de hacer es archivar una forma de
            // trabajar, no empezar a editarla.
            if(p?.id){ setProjTab("plantillas"); setProjAbierto(null); proyectos.setDetalle(null); }
          }}
          onClose={()=>setModal(null)}/>
      )}
      {modal?.type==="usarProtocolo"&&(
        <ProtocoloForm modo="usar" origen={modal.plantilla} teams={teams}
          pasos={Number(modal.plantilla?.tareas || 0)}
          inS={inS} lbS={lbS}
          onSave={async d=>{
            const p = await proyectos.instanciarPlantilla(modal.plantilla.id, d);
            setModal(null);
            // Aqui si se entra: nace un proyecto que hay que fechar y
            // arrancar, y lo primero es verlo.
            if(p?.id){ setProjTab("general"); setProjAbierto(p.id); proyectos.loadProyecto(p.id); }
          }}
          onClose={()=>setModal(null)}/>
      )}
    </>
  );
}
